import Backbone from 'backbone';
import { CHANNEL_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { showRejectFeedbackPopup } from '@bingads-webui-campaign-react/recommendation-feedback-modal';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
import template from './grid-reject-button.pug';

export class RejectButton extends Backbone.View {
  initialize({
    i18n,
    recommendationService,
    recommendationType,
    callback,
    category,
    guid,
    readOnly,
  }) {
    const { scope } = recommendationService;
    const level = scope ? scope.levelAt : levelAtConstant.ACCOUNT;
    const adGroupIdVNext = scope && scope.adGroupId ? [scope.adGroupId] : [];
    const campaignAdGroups = level !== levelAtConstant.ACCOUNT ? [{
      Key: scope.campaignId,
      Value: adGroupIdVNext,
    }] : [];
    this.i18n = i18n;
    this.helpId = 'pop_BA_Recommendations_StopShowingRec';
    this.options = {
      i18n,
      dataService: recommendationService,
      el: '#summary_tab_recommendations',
      data: { type: recommendationType, channel: CHANNEL_TYPES.RECOMMENDATION, campaignAdGroups },
      guid,
      context: { Source: null, Level: level, Category: category },
      callback,
      readOnly,
    };
  }
  get events() {
    return { 'click .btn.btn-reject': 'showModal' };
  }
  showModal() {
    const { options } = this;
    showRejectFeedbackPopup(options);
  }
  render() {
    const {
      i18n, helpId, options: { readOnly },
    } = this;
    this.$el.html(template({ i18n, helpId, readOnly }));
    return this;
  }
}
